import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AuthGuard from "./components/AuthGuard/AuthGuard";
import Header from "./components/Header/Header";
import HomePage from "./Homepage/Homepage";
import TableDetails from "./Passages/Passages";
import VocabularyDetails from "./Vocabulary/Vocabulary";
import CitiesManager from "./Landmarks/Landmarks";
import Course from "./Course/Course";
import Lesson from "./Lesson/Lesson_New";
import TriviaDetails from "./Trivia/Trivia";
import CourseMetrics from "./Metrics/CourseMetrics";
import CourseCustomization from "./CourseCustomization/CourseCustomization";
import AnalyticsDashboard from "./Analytics/AnalyticsDashboard";
import AffiliateDashboard from "./Affiliate/AffiliateDashboard";
import CourseProgress from "./CourseProgress/CourseProgress";
import SpeechSentencePractice from "./Lesson/SpeechSentencePractice/SpeechSentencePractice";
import TranslationMediatorManager from "./Lesson/TranslationMediator/TranslationMediator";

import FillInTheBlank from "./Lesson/FillInTheBlank/FillInTheBlank";
import SentenceTranslationGenerator from "./Lesson/SentenceTranslation/SentenceTranslation";
import ImageList from "./ImageList/ImageList";
import Objectives from "./Lesson/Objectives/Objectives"; // Assuming paths
import WordDescriptions from "./Lesson/WordDescriptions/WordDescriptions"; // Assuming paths
import WordsToDescribe from "./Lesson/WordsToDescribe/WordsToDescribe"; // Assuming paths
import SectionMediaManager from "./SectionMedia/SectionMediaManager";
import UserManagement from "./Admin/UserManagement/UserManagement";
import LanguageInstructions from "./LanguageInstructions/LanguageInstructions";
import Feedback from "./Feedback/Feedback";

const App = () => {
  return (
    <AuthProvider>
      <AuthGuard>
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          <Header />
          <main style={{ flex: 1, padding: "20px" }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/passages" element={<TableDetails />} />
              <Route path="/vocabulary" element={<VocabularyDetails />} />
              <Route path="/cities" element={<CitiesManager />} />
              <Route path="/course" element={<Course />} />
              <Route path="/Lessons" element={<Lesson />} />
              <Route path="/metrics" element={<AnalyticsDashboard />} />
              <Route path="/affiliate" element={<AffiliateDashboard />} />
              <Route path="/metrics/course" element={<CourseMetrics />} />
              <Route path="/trivia" element={<TriviaDetails />} />
              <Route path="/course-customization" element={<CourseCustomization />} />
              <Route path="/course-progress" element={<CourseProgress />} />
              <Route path="/lessons" element={<Lesson />} />

              <Route path="/lessons/fill-in-the-blank" element={<FillInTheBlank />} />
              <Route
                path="/lessons/sentence-translation"
                element={<SentenceTranslationGenerator />}
              />
              <Route path="/lessons/image-list" element={<ImageList />} />
              <Route path="/lessons/objectives" element={<Objectives />} />
              <Route path="/lessons/word-descriptions" element={<WordDescriptions />} />
              <Route path="/lessons/words-to-describe" element={<WordsToDescribe />} />
              <Route
                path="/lessons/speech-sentence-practice"
                element={<SpeechSentencePractice />}
              />
              <Route
                path="/lessons/translation-mediator"
                element={<TranslationMediatorManager />}
              />
              <Route path="/section-media" element={<SectionMediaManager />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/language-instructions" element={<LanguageInstructions />} />
              <Route path="/feedback" element={<Feedback />} />
            </Routes>
          </main>
        </div>
      </AuthGuard>
    </AuthProvider>
  );
};

export default App;
